// extracted by mini-css-extract-plugin
export var li = "_uq-2";
export var ol = "_uq-1";
export var ul = "_uq-0";